export const DOWNLOADED_COPY = 'File Downloaded!';
export const UNKNOWN_ERROR_COPY = 'Unknown Error!';
export const FOUR_ONE_THREE_ERROR_COPY = 'File Upload Size Over 50MB! Try Compressing Your Images!';
